import { Skeleton } from '@comeon/ui';
import VirtualizedGameItemsContainer from '../explore/virtualized-game-items-container';
import styled from 'styled-components';
import breakpoint from '~/utils/style-utils';

const StyledSkeleton = () => <Skeleton borderRadius="12px" />;

const GamesGridSkeleton = () => {
	return (
		<VirtualizedGameItemsContainer
			GameItemComponent={StyledSkeleton}
			games={Array.from({ length: 100 }, (_, i) => ({ code: String(i + 1) }))}
		/>
	);
};

export const GamesGridSkeletonContainer = styled.div`
	overflow-x: hidden;
	padding: 12px;
	${breakpoint.lg`
		padding: 12px 24px 56px 24px;
	`}
`;

export default GamesGridSkeleton;
